<template>
    <div class="tabs">
        <div class="tab" v-for="tab in tabs" :key="tab.tabId" :class="{active: activeTabId === tab.tabId}"
             @click="clickTab(tab)">
            <div class="content">
                <div class="wrapper">
                    <span>{{tab.tabLabel}}</span>
                    <button class="close-button" @click.stop="closeTab(tab)"><i class="gf gf-close"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DocumentTabs",
        props: {
            tabs: Array,
            activeTabId: String
        },
        methods: {
            clickTab (tab) {
                this.$emit('clickTabWithId', tab.tabId)
            },
            closeTab (tab) {
                this.$emit('closeTabWithId', tab.tabId)
            }
        }
    }
</script>

<style scoped lang="scss">
    .tabs {
        display: flex;
        align-items: center;

        .tab {
            font-size: 0.95em;
            padding: 0 10px 0 10px;
            position: relative;
            line-height: 30px;
            user-select: none;

            .close-button {
                background-color: transparent;
                border: none;
                outline: none;
                padding: 0;
                margin-left: 0.5rem;
                color: gray;
                box-shadow: none;
                &:hover {
                    color: red;
                }
            }

            .content {
                position: relative;

                .wrapper {
                    position: relative;
                    white-space: nowrap;
                }
            }

            &.active {
                .content {
                    &:before {
                        content: '';
                        display: block;
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        left: -2px;
                        top: -4px;
                        background-image: url("../assets/tab_m4px.svg");
                        background-repeat: repeat-x;
                    }
                }

                &:before {
                    content: '';
                    display: block;
                    position: absolute;
                    right: -12px;
                    bottom: 0;
                    left: -14px;
                    top: -4px;
                    background-image: url("../assets/tab_r_1.svg"), url("../assets/tab_l_1.svg");
                    background-repeat: no-repeat, no-repeat;
                    background-position: right, left;
                }
            }

            &:not(.active):not(:last-child) {
                &:after {
                    content: '';
                    display: block;
                    height: 1rem;
                    width: 1px;
                    background-color: gray;
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translate3d(0, -50%, 0);
                }
            }
        }
    }
</style>
